import { render, staticRenderFns } from "./FormItemNodeTransfer.vue?vue&type=template&id=0c7365a8&scoped=true"
import script from "./FormItemNodeTransfer.vue?vue&type=script&lang=js"
export * from "./FormItemNodeTransfer.vue?vue&type=script&lang=js"
import style0 from "./FormItemNodeTransfer.vue?vue&type=style&index=0&id=0c7365a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7365a8",
  null
  
)

export default component.exports